/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import InlineResponse20012Building from './InlineResponse20012Building';
import InlineResponse20012EventCalendars from './InlineResponse20012EventCalendars';
import InlineResponse20012StartDateJoin from './InlineResponse20012StartDateJoin';

/**
 * The InlineResponse20012Events model module.
 * @module model/InlineResponse20012Events
 * @version 1.0.0
 */
class InlineResponse20012Events {
    /**
     * Constructs a new <code>InlineResponse20012Events</code>.
     * @alias module:model/InlineResponse20012Events
     */
    constructor() { 
        
        InlineResponse20012Events.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse20012Events</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse20012Events} obj Optional instance to populate.
     * @return {module:model/InlineResponse20012Events} The populated <code>InlineResponse20012Events</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse20012Events();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('building')) {
                obj['building'] = InlineResponse20012Building.constructFromObject(data['building']);
            }
            if (data.hasOwnProperty('join_max')) {
                obj['join_max'] = ApiClient.convertToType(data['join_max'], 'Number');
            }
            if (data.hasOwnProperty('start_date_join')) {
                obj['start_date_join'] = InlineResponse20012StartDateJoin.constructFromObject(data['start_date_join']);
            }
            if (data.hasOwnProperty('end_date_join')) {
                obj['end_date_join'] = InlineResponse20012StartDateJoin.constructFromObject(data['end_date_join']);
            }
            if (data.hasOwnProperty('is_enrolled')) {
                obj['is_enrolled'] = ApiClient.convertToType(data['is_enrolled'], 'Boolean');
            }
            if (data.hasOwnProperty('event_calendars')) {
                obj['event_calendars'] = ApiClient.convertToType(data['event_calendars'], [InlineResponse20012EventCalendars]);
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
InlineResponse20012Events.prototype['id'] = undefined;

/**
 * @member {String} description
 */
InlineResponse20012Events.prototype['description'] = undefined;

/**
 * @member {module:model/InlineResponse20012Building} building
 */
InlineResponse20012Events.prototype['building'] = undefined;

/**
 * @member {Number} join_max
 */
InlineResponse20012Events.prototype['join_max'] = undefined;

/**
 * @member {module:model/InlineResponse20012StartDateJoin} start_date_join
 */
InlineResponse20012Events.prototype['start_date_join'] = undefined;

/**
 * @member {module:model/InlineResponse20012StartDateJoin} end_date_join
 */
InlineResponse20012Events.prototype['end_date_join'] = undefined;

/**
 * @member {Boolean} is_enrolled
 */
InlineResponse20012Events.prototype['is_enrolled'] = undefined;

/**
 * @member {Array.<module:model/InlineResponse20012EventCalendars>} event_calendars
 */
InlineResponse20012Events.prototype['event_calendars'] = undefined;






export default InlineResponse20012Events;

